import type { Theme } from '@mui/material';

/**
 * The clash ring, defined once: both people changed this field, so it wears the
 * warning ink at two pixels. It is drawn on the border or an inset shadow
 * (never `outline`), so the keyboard-focus ring stays a separate channel.
 */
const CLASH_COLOUR = 'statusInk.warn';
const CLASH_WIDTH = 2;

/** For an MUI outlined input: the notched border itself takes the ring. */
export const staleClashInputSx = {
  '& .MuiOutlinedInput-notchedOutline': { borderColor: CLASH_COLOUR, borderWidth: CLASH_WIDTH },
};

/** For a wrapper around a control that has no border of its own (a select, a toggle, an editor). */
export const staleClashRingSx = (theme: Theme) => ({
  borderRadius: 1,
  p: 0.75,
  boxShadow: `inset 0 0 0 ${CLASH_WIDTH}px ${theme.palette.statusInk.warn}`,
});
